// import sensors from 'sa-sdk-javascript'
// const testUri = 'https://zxdr.17zuoye.com:8106/sa?project=default'
// const prodUri = 'https://zxdr.17zuoye.com:8106/sa?project=production'
// let baseUri = testUri
// let channel = 'test'
// if (location.href.includes('17zuoye.com')) {
//   baseUri = prodUri
//   channel = 'product'
// } else if (location.href.includes('17zuoye.net')) {
//   baseUri = testUri
//   channel = 'test'
// }

// sensors.init({
//   sdk_url: '//cdn-cnc.17zuoye.cn/s17/lib/zx/sensors/14.13/sensorsdata.min.js?t='+ String(new Date().getTime()).substr(0,8),
//   // server_url: 'https://zxdr.17zuoye.com:8106/sa?project=production',
//   server_url: baseUri,
//   // heatmap_url神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。如果神策代码中 `sensorsdata.min.js` 版本是 1.9.1 及以上版本，这个参数必须配置，低于此版本不需要配置。
//   heatmap_url: 'https://cdn.jsdelivr.net/npm/sa-sdk-javascript@1.13.10/heatmap.min.js',
//   // web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置。
//   // web_url: '神策分析后台地址',
//   show_log: true,
//   debug_mode: false,
//   heatmap: {
//     // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
//     // 需要 JSSDK 版本号大于 1.7
//     clickmap: 'default',
//     // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
//     // 需要 JSSDK 版本号大于 1.9.1
//     scroll_notice_map: 'not_collect'
//   },
//   logConfig: {
//     channel: `vox_logs:junior_${channel}`,
//     commonData: {
//       app: 'cmine',
//       env: channel
//     }
//   }
// })
const sensors = (window as any).sa
export { sensors as sa }
